export default __webpack_public_path__ + "static/media/mingkang.5d5e2217.jpeg";